/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { string as codecString } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { BaseError } from './BaseError';
const RepositoryConnectionLimitReachedExceptionParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['webhookId', codecString, 'webhook_id'],
]), BaseError);
export class RepositoryConnectionLimitReachedException extends BaseError {
    static decode(input) {
        return RepositoryConnectionLimitReachedExceptionParser.decode(input).map(res => new RepositoryConnectionLimitReachedException(res));
    }
    static unsafeDecode(input) {
        return RepositoryConnectionLimitReachedException.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return RepositoryConnectionLimitReachedExceptionParser.encode(data);
    }
    static schema() {
        return RepositoryConnectionLimitReachedExceptionParser.schema();
    }
}
